export const baseURL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3100/v1/';
export const managerURL = process.env.REACT_APP_MANAGER_URL || 'https://manager.meritu.local/';
export const domainCookie = process.env.REACT_APP_DOMAIN_COOKIE || '';
export const env = process.env.REACT_APP_ENV || 'dev';
// 'https://meritu-dotco2.uc.r.appspot.com/v1/'
